import service from '@/utils/server';

const modName='/bd/collectionConfirm/';
//查询结算信息
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//结算确认
export const collectionSubmit = data => {
  return service({
    url: modName + 'collectionSubmit',
    method: 'post',
    data
  });
};

//结算确认批量
export const collectionBatchSubmit = data => {
  return service({
    url: modName + 'collectionBatchSubmit',
    method: 'post',
    data
  });
};

//结算详情
export const collectionDetails = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};


export const paymentSummaryExport = data => {
  return service({
    url: modName + 'paymentSummaryExport',
    method: 'post',
    responseType: 'blob',
    data
  });
};



export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const selfProductionCertificateExport = data => {
  return service({
    url: modName + 'selfProductionCertificateExport',
    method: 'post',
    responseType: 'blob',
    data
  });
};

export const invoicingExport = data => {
  return service({
    url: modName + 'invoicing',
    method: 'post',
    responseType: 'blob',
    data
  });
};


export const collectionRollback = data => {
  return service({
    url: modName + 'collectionStatusBack',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionConfirm/api/index.js